import installApp from 'appConfig/installApp';

import isMobile from './isMobile';

export const getQrCodeLink = () => {
    return isMobile.android() ? installApp.googlePlayAppLink : installApp.appStoreAppLink;
};
